import { render } from "./boletinprodnuevos.vue?vue&type=template&id=231e6d2a&scoped=true"
import script from "./boletinprodnuevos.vue?vue&type=script&lang=js"
export * from "./boletinprodnuevos.vue?vue&type=script&lang=js"

import "./boletinprodnuevos.vue?vue&type=style&index=0&id=231e6d2a&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231e6d2a"]])

export default __exports__